import bannerImage from "../../assets/images/category-banners/men-tshirts.png";
import bannerImageHiDPI from "../../assets/images/category-banners/men-tshirts-hidpi.png";

export default {
  h1Text: `Печать на мужских футболках`,
  h2Text: `Прямая печать на футболках от 1 шт.`,
  regularTextHtml: `<p>Printio – это быстрая и качественная печать футболок с логотипом, надписью или фото на заказ. Нанесем картинку из каталога, либо сделаем печать по индивидуальному рисунку. Сделать футболку со своим дизайном можно при помощи онлайн конструктора. Срок нанесения надписи, логотипа или принта на футболку или майку в Москве, в зависимости от объема печати - 1-2 дня.</p>`,
  buttonText: `Выбрать футболку`,
  image: [bannerImage, bannerImageHiDPI]
};
